<template>
  <div class="middle-remote">
    <div class="header-row">
      <div class="title-section">
        <img src="@/assets/gisWork/SVG/title-bg.svg" class="title-bg" />
        <span class="title-text">远传表(流量计)统计</span>
      </div>
      <div class="total-value">
        <span class="number">{{ totalNum }}</span>
        <span class="unit">个</span>
      </div>
    </div>

    <!-- 饼图容器 -->
    <div class="chart-container">
      <div ref="chartContainer" class="chart"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'MiddleRemote',
  data () {
    return {
      remoteUrl: '/pipe-network/gis/pipe-networks/workbench/remote-water-meter',
      totalNum: 0,
      chart: null
    }
  },
  mounted () {
    this.fetchRemoteData()
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    async fetchRemoteData () {
      try {
        const response = await this.$http.get(this.remoteUrl)
        const apiData = response.data

        // 更新总数
        this.animateNumber(apiData.remoteWaterMeterNum)

        // 初始化图表
        this.initChart(apiData.remoteWaterMeterTypeVos)

      } catch (error) {
        console.error('获取远程监控数据失败:', error)
      }
    },
    animateNumber (targetValue) {
      const startValue = 0
      const duration = 2000
      const startTime = Date.now()

      const animate = () => {
        const elapsed = Date.now() - startTime
        const progress = Math.min(elapsed / duration, 1)

        const easeOutQuart = 1 - Math.pow(1 - progress, 4)
        const currentValue = startValue + (targetValue - startValue) * easeOutQuart

        this.totalNum = Math.round(currentValue)

        if (progress < 1) {
          requestAnimationFrame(animate)
        } else {
          this.totalNum = targetValue
        }
      }

      animate()
    },
    initChart (chartData) {
      if (this.chart) {
        this.chart.dispose()
      }

      this.$nextTick(() => {
        this.chart = echarts.init(this.$refs.chartContainer)

        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}个 ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: '5%',
            top: 'center',
            itemWidth: 14,
            itemHeight: 10,
            textStyle: {
              fontSize: 12
            }
          },
          series: [
            {
              name: '远程水表',
              type: 'pie',
              radius: ['25%', '45%'],
              center: ['35%', '50%'],
              data: chartData.map(item => ({
                name: item.diameter,
                value: item.number
              })),
              itemStyle: {
                borderRadius: 3,
                borderColor: '#fff',
                borderWidth: 1
              },
              label: {
                show: true,
                position: 'outside',
                formatter: '{b}\n{d}%',
                fontSize: 9
              },
              labelLine: {
                show: true,
                length: 8,
                length2: 3
              }
            }
          ]
        }

        this.chart.setOption(option)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.middle-remote {
  width: 33%;
  height: 550px;
  padding: 10px;
  padding-bottom: 20px;
  border-radius: 10px;
  background-color: white;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-section {
  position: relative;
  display: inline-block;

  .title-bg {
    width: 250px;
    height: 50px;
    object-fit: contain;
  }

  .title-text {
    position: absolute;
    top: 47%;
    left: 40%;
    transform: translate(-50%, -50%);
    color: #093d97;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    z-index: 2;
  }
}

.total-value {
  font-size: 24px;
  margin-right: 10px;
  font-style: italic;

  .number {
    font-weight: 700;
    color: #0a8d97;
  }

  .unit {
    font-size: 14px;
    font-weight: 600;
    color: #92cbd7;
    margin-left: 2px;
  }
}

.chart-container {
  width: 100%;
  height: calc(100% - 70px);
  margin-top: 10px;
}

.chart {
  width: 100%;
  height: 100%;
}
</style>
